import React from 'react';
import styles from './Leaderboard.module.css';
import clsx from 'clsx';
import { ListLeaderboardDataItem } from '../../interfaces/LeaderboardTypes';
import userIcon from "../../assets/user-icon.svg"
import { _isEmpty } from '../../utils/helpers/zupeeLodash';
import ImageComponent from '../../components/ImageComponent';
import { getHeight, getWidth } from '../../utils/relativeSizes';
import { isEmpty } from 'lodash';
import { useSwitchStore } from '../../storage/switchState';

interface LeaderboardEntry {
  rank: number;
  name: string;
  score: number;
  avatarUrl: string;
  entryNumber: number;
  isCurrentUser?: boolean;
}
interface LeaderboardRowProps {
  entry: ListLeaderboardDataItem;
  highlighted?: boolean;
  rowNumber :Number
}
export const LeaderboardRow: React.FC<LeaderboardRowProps> = ({ entry, highlighted,rowNumber }) => {
  const { rabu } = useSwitchStore();
  const imgUri = `${rabu}${entry?.userProfilePic}`;
  const rowClassName = highlighted ? styles.highlightedRow : styles.row;
  const entrylabelcolor = highlighted ? styles.entrylabelHighlighted : styles.entrylabel;
  // console.log("entryentry", entry)
  
  return (
    <div className={clsx(rowClassName, "fontWeightMedium ")}>
      <div className={clsx(styles.rank,"fontSizeSm12 fontWeightMedium")}>{entry.rank}</div>
      <div className={styles.playerInfo}>
        <ImageComponent
          src={imgUri}
          fallbackSrc={userIcon}
          alt={`${entry?.userFullName}'s avatar`}
          className={clsx(styles.avatar, `${(entry?.userProfilePic ? "" : styles.defaultAvatar )}`)}
        />
        <div className={styles.playerDetails}>
          <div className={styles.overflowScroll}>
            <div className={clsx(styles.nameScoreContainer,"fontSizeSm12")}>
              <div>{entry?.userFullName}</div>
            </div>
          </div>
          <div className={clsx(entrylabelcolor,"fontSizeXs textUppercase")}>
            {entry?.entryText}
          </div>
          {/* <div className={clsx(entrylabelcolor,"fontSizeXs")}>
            {entry?.entryText}
          </div> */}
        </div>  
      </div>
      <div className={clsx(styles.score,"fontSizeSm12 fontWeightMedium")}>{entry?.score}</div>
      {/* <div className={clsx(styles.score,"fontSizeSm12 fontWeightMedium")}>{entry?.reward}</div> */}
    </div>
  );
};